import { render, staticRenderFns } from "./AccountConfigLayout.vue?vue&type=template&id=e0654a42"
import script from "./AccountConfigLayout.vue?vue&type=script&lang=js"
export * from "./AccountConfigLayout.vue?vue&type=script&lang=js"
import style0 from "./AccountConfigLayout.vue?vue&type=style&index=0&id=e0654a42&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports